export enum ActionType {
    WP_MAIN__RELOAD = 'FL_WP_MAIN__RELOAD',
    WP_MAIN__RELOAD_RESULT = 'FL_WP_MAIN__RELOAD_RESULT',
}
